import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/i18n/LanguageContext";
import Nav from "@/components/site/Nav";
import Footer from "@/components/site/Footer";
import HomePage from "@/pages/HomePage";
import VillagePage from "@/pages/VillagePage";
import EsperienzePage from "@/pages/EsperienzePage";
import EchoesPage from "@/pages/EchoesPage";
import ProgettoPage from "@/pages/ProgettoPage";
import EventiPage from "@/pages/EventiPage";
import PartnerPage from "@/pages/PartnerPage";
import ChiSonoPage from "@/pages/ChiSonoPage";
import ContattiPage from "@/pages/ContattiPage";
import CardPage from "@/pages/CardPage";

const ScrollManager = () => {
  const location = useLocation();
  useEffect(() => {
    const lenis = window.__lenis;
    if (location.hash) {
      const tryScroll = (attempts) => {
        const el = document.querySelector(location.hash);
        if (el && lenis) {
          lenis.scrollTo(el, { offset: -90, duration: 1.4 });
        } else if (attempts > 0) {
          setTimeout(() => tryScroll(attempts - 1), 120);
        }
      };
      setTimeout(() => tryScroll(10), 150);
    } else {
      if (lenis) lenis.scrollTo(0, { immediate: true });
      window.scrollTo(0, 0);
    }
  }, [location.pathname, location.hash]);
  return null;
};

const Shell = () => {
  const { pathname } = useLocation();
  const isCard = pathname.startsWith("/card");
  return (
    <>
      <ScrollManager />
      {!isCard && <Nav />}
      <main>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/borghi/:slug" element={<VillagePage />} />
          <Route path="/esperienze" element={<EsperienzePage />} />
          <Route path="/echoes-from-above" element={<EchoesPage />} />
          <Route path="/il-progetto" element={<ProgettoPage />} />
          <Route path="/eventi" element={<EventiPage />} />
          <Route path="/per-comuni-e-partner" element={<PartnerPage />} />
          <Route path="/chi-sono" element={<ChiSonoPage />} />
          <Route path="/contatti" element={<ContattiPage />} />
          <Route path="/card/:token" element={<CardPage />} />
        </Routes>
      </main>
      {!isCard && <Footer />}
    </>
  );
};

function App() {
  useEffect(() => {
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduced) return;
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <Shell />
          <Toaster position="bottom-center" toastOptions={{ style: { background: "#121212", color: "#F7F5F0", border: "1px solid rgba(197,160,89,0.35)" } }} />
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
